import React from 'react';
import { NavLink, Link, withRouter, useLocation } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Home } from 'react-feather';
import { getLocalizedName, trimText } from '../../../utility/util/util.service';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

// Helper to get ID from a relation that could be either an object or a string ID
const getParentId = (parent) => {
  if (!parent) return null;
  return typeof parent === 'string' ? parent : parent.id;
};

// Build the full ancestor chain (from root down to the direct parent)
const buildAncestorPath = (category, categories) => {
  const ancestors = [];
  let currentId = getParentId(category?.parent);
  while (currentId) {
    const id = currentId;
    const ancestor = categories?.find((c) => c.id === id);
    if (!ancestor) break;
    ancestors.unshift(ancestor); // prepend so order is root → ... → parent
    currentId = getParentId(ancestor.parent);
  }
  return ancestors;
};

const BreadCrumbs = ({ category, slug, title, categories }) => {
  const intl = useIntl();
  const { search } = useLocation();
  const ancestors = buildAncestorPath(category, categories);

  return (
    <div className="content-header mb-2">
      <div className="d-flex align-items-center justify-content-start">
        {title && (
          <span className="font-medium-3 mr-1 primary d-none d-lg-block">
            {title}
          </span>
        )}
        <div className="breadcrumb-wrapper vx-breadcrumbs d-sm-block">
          <Breadcrumb tag="div" listClassName="mb-0">
            <BreadcrumbItem tag="li">
              <NavLink to={`/store/${slug}${search || ''}`}>
                <Home className="align-top primary" size={18} />
              </NavLink>
            </BreadcrumbItem>
            {ancestors.map((ancestor) => (
              <BreadcrumbItem tag="li" className="primary" key={ancestor.id}>
                <Link to={`/store/${slug}/${ancestor.id}${search || ''}`}>
                  {trimText(
                    getLocalizedName(ancestor, intl.locale),
                    30,
                    ' ...',
                  )}
                </Link>
              </BreadcrumbItem>
            ))}

            {category && (
              <BreadcrumbItem tag="li" active>
                {trimText(getLocalizedName(category, intl.locale), 30, ' ...')}
              </BreadcrumbItem>
            )}
          </Breadcrumb>
        </div>
      </div>
    </div>
  );
};

BreadCrumbs.propTypes = {
  category: PropTypes.object,
  slug: PropTypes.string,
  title: PropTypes.string,
};

export default withRouter(BreadCrumbs);
